import AV from 'leancloud-storage'
var APP_ID = 'jtP7IlVD1aOBkUvgoue8BsWG-gzGzoHsz'
var APP_KEY = 'SQbJtem0VkQlb1VGc4RiaI2u'

AV.init({
  appId: APP_ID,
  appKey: APP_KEY
})
 
 export default AV


// WEBPACK FOOTER //
// ./src/utils/leancloud storage.js